import pick from 'lodash/pick'
import type { ScheduleEventGameData, WebsocketMessage } from '~/types'

export const liveGameDataGameInfoDto = (source: WebsocketMessage.EventMessage): ScheduleEventGameData.GameInfo => {
  const { message: { payload: { game } } } = source

  const summary: ScheduleEventGameData.Summary = {
    home: <ScheduleEventGameData.Team>pick(game.summary!.home, ['name', 'market', 'alias', 'points']),
    away: <ScheduleEventGameData.Team>pick(game.summary!.away, ['name', 'market', 'alias', 'points']),
  }
  return {
    ...<ScheduleEventGameData.GameInfo>pick(game, ['id', 'status', 'quarter', 'clock']),
    summary,
  }
}
